var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("i", {
      staticClass: "el-icon-delete-solid",
      on: { click: _vm.handleClearCache },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }